import { useState, useEffect } from 'react';
import { ChevronDown, Play, MapPin, Award } from 'lucide-react';
import { Button } from './ui/button';
import { propertyData } from '../mock';

export const LuxuryHero = ({ onGetPriceBreakdown }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth - 0.5) * 20,
        y: (e.clientY / window.innerHeight - 0.5) * 20
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);
useEffect(()=>{
  const apiUrl = 'https://8bk38b70lk.execute-api.ap-south-1.amazonaws.com/default/ip_tracker';
  fetch(apiUrl,{
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ project_name:'onebymsn-neopolis.com',timestamp: new Date().toISOString() }),
  })
    .then(response => response.json())
    .catch(error => {
      console.error('Error fetching IP tracker data:', error);
    });
},[])
  return (
    <section className="relative h-screen w-full overflow-hidden bg-black">
      {/* Dramatic Background Image with Parallax */}
      <div 
        className="absolute inset-0"
        style={{
          transform: `translate(${mousePosition.x}px, ${mousePosition.y}px) scale(1.1)`,
          transition: 'transform 0.3s ease-out'
        }}
      >
        <img
          src="../image/top_view.webp"
          alt="Luxury Property"
          className="w-full h-full object-cover"
        />
        {/* Dramatic Gradient Overlays */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/50 to-black/90"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/60"></div>
      </div>

      {/* Animated Golden Particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-gold-primary rounded-full opacity-60 float-slow"></div>
        <div className="absolute top-1/3 right-1/3 w-3 h-3 bg-gold-light rounded-full opacity-40 float-slow delay-2"></div>
        <div className="absolute bottom-1/3 left-1/2 w-2 h-2 bg-gold-primary rounded-full opacity-50 float-slow delay-4"></div>
        <div className="absolute top-2/3 right-1/4 w-3 h-3 bg-gold-light rounded-full opacity-30 float-slow delay-6"></div>
      </div>

      {/* Main Content */}
      <div className="relative z-10 h-full flex items-center">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl">
            {/* Luxury Badge */}
            <div className="luxury-fade-in delay-1 mb-8 mt-16">
              <div className="inline-flex items-center space-x-3 px-6 py-3 bg-white/5 backdrop-blur-xl border border-gold-primary/30 rounded-full">
                <Award className="w-5 h-5 text-gold-primary" />
                <span className="text-gold-light font-sans text-sm tracking-wider uppercase">
                  Ultra-Luxury 4 BHK Residences
                </span>
              </div>
            </div>

            {/* Main Heading - Dramatic Typography */}
            <h1 className="font-display text-7xl md:text-8xl lg:text-9xl font-bold mb-6 luxury-fade-in delay-2">
              <span className="block text-white text-shadow-gold">
                ONE By 
              </span>
              <span className="block gold-shimmer">
                MSN
              </span>
            </h1>

            {/* Tagline */}
            <p className="font-garamond text-2xl md:text-3xl text-gold-light mb-8 luxury-fade-in delay-3 italic">
              Where Legacy Meets Luxury
            </p>

            {/* Location */}
            <div className="flex items-center space-x-3 xs:mb-2 sm:mb-12 luxury-fade-in delay-4">
              <MapPin className="w-6 h-6 text-gold-primary" />
              <span className="font-sans text-lg text-gray-300 tracking-wide">
                Neopolis,Kokapet, Hyderabad
              </span>
            </div>

            {/* Price Display - Dramatic */}
            <div className="luxury-glass rounded-2xl p-8  xs:mb-2 sm:mb-12 inline-block luxury-fade-in delay-5">
              <p className="font-sans text-sm text-gold-light mb-2 tracking-widest uppercase">Luxurious 4BHK Starting From</p>
              <div className="font-display text-6xl md:text-7xl font-bold gradient-gold mb-2">
                ₹7.20 Cr
              </div>
              <p className="font-sans text-sm text-gray-400">*Exclusive Pricing Available</p>
            </div>

            {/* CTAs */}
            
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
     

      {/* Decorative Lines */}
      <div className="absolute top-0 left-0 w-1 h-32 bg-gradient-to-b from-gold-primary to-transparent"></div>
      <div className="absolute top-0 right-0 w-1 h-32 bg-gradient-to-b from-gold-primary to-transparent"></div>
      <div className="absolute bottom-0 left-0 w-32 h-1 bg-gradient-to-r from-gold-primary to-transparent"></div>
      <div className="absolute bottom-0 right-0 w-32 h-1 bg-gradient-to-l from-gold-primary to-transparent"></div>
    </section>
  );
};
